import { CheckboxProps } from '@storeblocks/checkbox-atom';
import Checkboxes from '@storeblocks/checkboxes';
import { useField } from 'formik';

interface FormCheckboxProps {
  name: string;
  options: CheckboxProps[];
  disabled?: boolean;
  error?: string;
}

export function FormCheckbox({
  name,
  options,
  disabled,
  error,
}: FormCheckboxProps): JSX.Element {
  const [field, , helpers] = useField<string[]>(name);

  const rolesWithChecked = options.map((option) => ({
    ...option,
    checked: field.value ? field.value.includes(option.value!) : false,
  }));

  return (
    <Checkboxes
      data-test="assignable-roles-checkboxes"
      options={rolesWithChecked}
      disabled={disabled}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        const currentValue = field.value || [];
        if (e.target.checked) {
          helpers.setValue([...currentValue, value]);
        } else {
          helpers.setValue(currentValue.filter((v) => v !== value));
        }
      }}
      groupName={name}
      alertMessage={error || undefined}
      alertMessageType={error ? 'error' : undefined}
      fluid
    />
  );
}
